import { get } from 'lodash';
import { resolve, reject } from 'redux-optimist-promise';

export const FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
const UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';

type CartBooking = {
  bookingId: string;
  isEmpty: boolean;
  [key: string]: unknown;
};

type CartData = {
  bookingsCart?: {
    cartBookings: CartBooking[];
    amount?: { total?: Record<string, unknown> };
    isEmpty?: boolean;
    [key: string]: unknown;
  };
};

type CartState = {
  data: CartData;
  errorResponse: { errors?: unknown[] };
  editingBookingId: string;
};

type CartAction = {
  type?: string;
  payload?: {
    errors?: unknown[];
    bookingId?: string;
    addServiceCart?: { cart?: unknown; totalAmount?: Record<string, unknown> };
    removeServiceCart?: { cart?: unknown; totalAmount?: Record<string, unknown> };
    [key: string]: unknown;
  };
};

export const initialState: CartState = {
  data: {},
  errorResponse: {},
  editingBookingId: '',
};

export const cartReducer = (
  state: CartState = initialState,
  action: CartAction = {},
): CartState => {
  const cartBookings = state.data?.bookingsCart?.cartBookings ?? [];
  switch (action.type) {
    case FETCH_BOOKING_CART:
      return {
        ...state,
      };
    case resolve(FETCH_BOOKING_CART):
      return {
        ...state,
        data: get(action, 'payload', {}) as CartData,
        errorResponse: {},
      };
    case reject(FETCH_BOOKING_CART):
      return {
        ...state,
        errorResponse: {
          errors: action.payload?.errors,
        },
      };
    case UPDATE_BOOKING_CART:
      return {
        ...state,
        editingBookingId: action.payload?.bookingId ?? state.editingBookingId,
      };
    case resolve(UPDATE_BOOKING_CART):
      const bookingToUpdateIndex = cartBookings.findIndex(
        (booking) => booking.bookingId === state.editingBookingId,
      );
      const updatedCartBookings: CartBooking[] = [
        ...cartBookings.slice(0, bookingToUpdateIndex),
        {
          ...(action.payload?.addServiceCart?.cart as object),
          ...(action.payload?.removeServiceCart?.cart as object),
        } as CartBooking,
        ...cartBookings.slice(bookingToUpdateIndex + 1),
      ];
      return {
        ...state,
        data: {
          ...state.data,
          bookingsCart: {
            ...state.data.bookingsCart,
            amount: {
              total: {
                ...state.data.bookingsCart?.amount?.total,
                ...action.payload?.addServiceCart?.totalAmount,
                ...action.payload?.removeServiceCart?.totalAmount,
              },
            },
            isEmpty: updatedCartBookings.every((cart) => cart.isEmpty),
            cartBookings: updatedCartBookings,
          },
        },
      };
    case reject(UPDATE_BOOKING_CART):
      return {
        ...state,
        errorResponse: {
          errors: action.payload?.errors,
        },
      };
    default:
      return state;
  }
};
